import 'css-chunksrc/client/pages/obsPage/heading/styles.scss';export default {
  "heading": "_heading_ubijy_1",
  "label": "_label_ubijy_16",
  "nameHeading": "_nameHeading_ubijy_24",
  "controls": "_controls_ubijy_30",
  "cogWheel": "_cogWheel_ubijy_36",
  "cogIcon": "_cogIcon_ubijy_45"
};